/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".light-red-color[_ngcontent-%COMP%] {\n  color: #ff5758; }\n\n.modal-header-color[_ngcontent-%COMP%] {\n  background-color: #ff5758;\n  color: white; }"];
export { styles as styles };



// WEBPACK FOOTER //
// /opt/app/src/app/core/delete-modal/delete-modal.component.scss.shim.ngstyle.js.pre-build-optimizer.js